import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { ValidationErrorsModule } from '../validation-errors/validation-errors.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { CheckListComponent } from './check-list.component';

@NgModule({
    declarations: [
        CheckListComponent,
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatInputModule,
        MatCheckboxModule,
        FuseSharedModule,
        ValidationErrorsModule,
        PhoenixDirectivesModule,
    ],
    exports: [
        CheckListComponent,
    ]
})
export class CheckListComponentModule
{
}
